import React, { useContext, useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import VodItem from "../vodItem";
import carouselImg from "../../assets/icons/svg/Icon awesome-angle-right.svg";
import { useHistory, useParams } from "react-router-dom";
import { getVodsByLabel, toggleFavById, getFavList } from "../../api/vod/vod";
import {
  getRelatedVods,
  getUserMaybeLikeData
} from "../../api/common/commonApi";
import { sendCustomFavoriteReport } from "../../utils/reporting/customReporting";
import TrashIcon from "../../assets/icons/svg/TrashIcon";
import AngleRightIcon from "../../assets/icons/svg/AngleRightIcon";
import localizationStrings from "../../statics/localization";
import { SessionContext } from "../../context/SessionContext";

const Carousel = ({
  column,
  slidesToShow,
  vod,
  label,
  margin,
  dontUseGrid,
  padding,
  onHoverItem
}) => {
  const [vods, setVods] = useState([]);
  const [isVertical, setIsVertical] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [favVodsLength, setFavVodsLength] = useState(0);
  const [slideIndex, setSlideIndex] = useState(0);
  const optionRef = useRef(null);
  const delCount = useRef(0);
  const timeoutRef = useRef(null);
  const slider = useRef(null);
  const pageNo = useRef(0);
  const vodRef = useRef([]);
  const totalCountRef = useRef(0);
  const { userFrameConfig, isChangeFavList } = useContext(SessionContext);
  const history = useHistory();

  let pageItemCount = 16; // request for other pages vod count

  slidesToShow = slidesToShow ? slidesToShow : isVertical ? 7 : 5;

  let slidesToScroll = isVertical ? 7 : 5;

  const getVodList = async (removeOldContents = false) => {
    const { data } = await getVodsByLabel(
      label.id,
      pageNo.current,
      pageItemCount
    );

    pageNo.current++;

    if (data.contents) {
      if (removeOldContents) vodRef.current = [];
      vodRef.current = vodRef.current.concat(data?.contents);
      totalCountRef.current = data?.totalContents;
      setVods(vodRef.current);

      setIsVertical(data?.vertical);
      if (pageNo.current === 1 && label?.id === 78) {
        timeoutRef.current && clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          slider.current && slider.current.slickGoTo(0);
        }, 200);
      }
    }
  };
  useEffect(() => {});
  const getUserFavList = async () => {
    setVods([]);
    const data = await getFavList("1,4,19", userFrameConfig.Search_Column);
    if (data.data.returncode === "0") {
      setVods(data.data.data);
      setFavVodsLength(data.data.data.length);

      timeoutRef.current && clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        slider.current && slider.current.slickGoTo(0);
      }, 200);
    } else {
      setFavVodsLength(0);
    }
  };

  const removeContentFromFavorite = async (item, isRemoveAll) => {
    let favType;

    // if (item?.favoritetype == "19") {
    //   favType = 19;
    // } else {
    //   if (item.programtype == 1 || item.programtype == 10) {
    //     favType = 1;
    //   } else if (parseInt(item.price)) {
    //     favType = 2;
    //   } else {
    //     favType = 4;
    //   }
    // }
    console.log("item", item.id);
    const data = await toggleFavById(item.id);

    if (data.status === 200) {
      if (isRemoveAll) {
        delCount.current++;
        if (delCount.current == vods.length) {
          setVods([]);
          setFavVodsLength(0);
        }
      } else {
        // vodRef.current = [];
        // setVods([]);
        pageNo.current = 0;
        getVodList(true); // first remove old contents
      }
    }
  };
  const next = () => {
    slider.current.slickNext();

    if (totalCountRef.current > vods?.length) {
      setTimeout(() => {
        getVodList();
      }, 600);
    }
  };

  useEffect(() => {
    if (label) {
      getVodList();
    }
  }, [label]);

  useEffect(() => {
    if (!!vod?.relatedContents) {
      slidesToShow = 4;
    }
  }, []);

  useEffect(() => {
    if (!!vod?.relatedContents) {
      setVods(vod?.relatedContents);
      setIsVertical(true);
      slidesToShow = 4;
    }
  }, [vod?.relatedContents]);

  useEffect(() => {
    if (isChangeFavList && label?.id === 78) {
      //vodRef.current = [];
      //setVods([]);
      pageNo.current = 0;
      getVodList(true); //first remove old contents
    }
  }, [isChangeFavList]);

  let isKeepWatching = label?.name === localizationStrings.continueToWatch;

  const items = vods?.map((vod, index) => {
    return (
      <VodItem
        key={vod.id}
        item={vod}
        showProgress={isKeepWatching}
        isFavList={label?.id === 78}
        useContentType={false}
        isVertical={isVertical}
        label={label}
        removeFromFav={(item) => removeContentFromFavorite(item, false)}
        index={index}
        onHoverItem={onHoverItem}
        slidesToScroll={slidesToScroll}
      />
    );
  });

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToScroll,
    arrows: false,
    draggable: false,
    lazyLoad: false,
    beforeChange: (currentSlide, nextSlide) => {
      setSlideIndex(nextSlide);
    }
  };

  return (
    <div
      className="content-carousel"
      style={{
        display: !vods.length ? "none" : "",
        padding: padding
      }}
      key={label?.id}
    >
      <label
        className="label-title"
        style={{
          marginLeft: margin
        }}
        onClick={() => {
          if (!dontUseGrid) {
            history.push(`/dashboard/genre/${label?.id}/${label?.name}`);
          }
        }}
        //label.columncode,label.columntype
      >
        {!!vod?.relatedContents ? (
          <span>{column?.columnname}</span>
        ) : (
          <span>{label?.name}</span>
        )}
        {!dontUseGrid ? (
          <img className="see-all-icon" src={carouselImg} />
        ) : null}

        {label?.id == "78" ? (
          <div
            ref={optionRef}
            className="dot-options"
            onClick={(e) => {
              e.stopPropagation();
              setShowOptions(!showOptions);
            }}
          >
            <div className="dots-wrapper" style={{ right: "0px" }}>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>

              <div className={`options-box ${showOptions ? "show" : ""}`}>
                <div className="tri-angle"></div>
                <div className="options">
                  <div
                    className="option asasa"
                    onClick={() => {
                      vods.forEach((item) => {
                        removeContentFromFavorite(item, true);
                      });
                    }}
                  >
                    <TrashIcon />
                    <span>{localizationStrings.removeList}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </label>

      <div className="slider-row">
        <div className="slick-wrapper">
          <Slider ref={slider} {...settings}>
            {items}
          </Slider>
        </div>
        <div
          className="direction-button prev"
          style={
            vods.length > slidesToShow && slideIndex !== 0
              ? {}
              : {
                  visibility: "hidden"
                }
          }
          onClick={() => slider.current.slickPrev()}
        >
          <span>
            <AngleRightIcon />
          </span>
        </div>
        <div
          className="direction-button next"
          style={
            vods.length > slidesToShow &&
            vods.length != slideIndex + slidesToShow
              ? {}
              : {
                  visibility: "hidden"
                }
          }
          onClick={() => next()}
        >
          <AngleRightIcon />
        </div>
      </div>
    </div>
  );
};

export default Carousel;
